import React from 'react';
import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');

import { Icon } from './Icon';

import OverflowButtonHorizontalIcon from '../icons/OverflowButtonHorizontalIcon';
import OverflowButtonVerticalIcon from '../icons/OverflowButtonVerticalIcon';

const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  height: 32px;
  width: 32px;
  border: none;
  border-radius: 50%;
  padding: 0;
  cursor: pointer;

  :hover {
    background-color: ${colors.N40A};
  }

  :active {
    background-color: ${colors.N50A};
  }
`;

const IconFill = Icon.extend`
  fill: ${colors.N100};
`;

const OverflowButton = ({
  iconHeight = 12,
  iconWidth = 12,
  isVertical,

  ...buttonProps
}) => (
  <Button {...buttonProps}>
    <IconFill height={iconHeight} width={iconWidth}>
      {isVertical ? (
        <OverflowButtonVerticalIcon />
      ) : (
        <OverflowButtonHorizontalIcon />
      )}
    </IconFill>
  </Button>
);

const styledOverflowButton = styled(OverflowButton)``;

export { styledOverflowButton as OverflowButton };



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-detail/OverflowButton.js